import { useCallback, useState, useEffect } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

function useGetCompanyConfigByKeys(autoFetch = true) {
    const [configData, setConfigData] = useState(null);
    const [loading, setLoading] = useState(autoFetch);
    const [error, setError] = useState(null);

    const fetchConfigByKeys = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getCompanyConfigByKeys",
                keys: ["xlRegistrationDealTypes"],
            });
            setConfigData(response?.data?.xlRegistrationDealTypes);
            return { data: response.data?.xlRegistrationDealTypes };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            toast.error(errorMessage);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    }, []);
    const checkCertificateNameCondition = (type) => {
        let isValid = false;
        if (
            type === "In House" ||
            type === "LVT In-House" ||
            type === "Consulting" ||
            type === "Coaching" ||
            type === configData
        ) {
            isValid = false;
        } else {
            isValid = true;
        }
        return isValid;
    };
    useEffect(() => {
        fetchConfigByKeys();
    }, [fetchConfigByKeys, autoFetch]);

    return { xlRegistrationDealTypes: configData, loading, error, fetchConfigByKeys, checkCertificateNameCondition };
}

export default useGetCompanyConfigByKeys;
